module.exports = __webpack_public_path__ + "img/logo-sm-dark.7aa02372.png";